module.exports = __webpack_public_path__ + "img/o-next.6f298bb2.png";